export const COOKIES = {
  authToken: 'exprowhite_trading',
};
